import classnames from 'classnames';
import { isValidElement, useMemo } from 'react';

import styles from './Avatar.module.scss';
import { AvatarProps, extractInitials } from './Avatar.types';

export const Avatar = ({ className, content, size, color, ...props }: AvatarProps) => {
  const children = useMemo(() => {
    if (isValidElement(content) || typeof content !== 'object' || content === null) return content;
    const firstName = content.firstName || content.given_name || '';
    const lastName = content.lastName || content.name || content.family_name || '';
    const initials = extractInitials([firstName, lastName].filter(Boolean).join(' '));
    if (content.picture) return <img alt={initials} src={content.picture} />;
    return initials;
  }, [content]);

  return (
    <div
      data-icon-size={
        {
          xxlarge: 'xxxlarge',
          xlarge: 'xxlarge',
          large: 'xlarge',
          medium: 'large',
          small: 'medium',
          xsmall: 'small',
          xxsmall: 'xsmall',
          xxxsmall: 'xxsmall',
        }[size]
      }
      className={classnames(styles.avatar, className, styles[size], styles[color])}
      {...props}
    >
      {children}
    </div>
  );
};
